import React from 'react'

import { Button, Grid } from '@material-ui/core'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import NoteAddIcon from '@material-ui/icons/NoteAdd'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
    },
  })
)

type Props = {
  onCreate: () => void
  isLoading: boolean
  isCanCreate: boolean
  isRevError: boolean
}

const Header: React.FC<Props> = (props: Props) => {
  const classes = useStyles()

  return (
    <Grid container alignItems="center" spacing={3} className={classes.root}>
      <Grid item md={2}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          startIcon={
            props.isLoading || props.isCanCreate ? <NoteAddIcon /> : <></>
          }
          onClick={props.onCreate}
          disabled={props.isLoading || !props.isCanCreate || props.isRevError}
        >
          {props.isLoading || props.isCanCreate
            ? '新規プロジェクト'
            : 'ダウンロード枚数上限に達しています'}
        </Button>
      </Grid>
    </Grid>
  )
}

export default Header
